export const THIN_ARROW_PATH = 'm60.462 0-25.017 49.99 25.017 50.01 4.09-2.033-23.977-47.978 23.978-47.955z';
